"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const exec_1 = require("../botones/exec");
class SlowInput extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleKeyPress = async (ev) => {
            if (this.props.onKeyPress) {
                this.props.onKeyPress(ev);
            }
            if (ev.key == "Enter") {
                await exec_1.execUserFunc(this.props.onEnter);
            }
        };
        this.handleOnChange = (e) => {
            if (this.props.onChange)
                this.props.onChange(e.target.value);
        };
    }
    render() {
        const props = this.props.onChange ?
            Object.assign({}, this.props, { value: undefined, onChange: undefined }) :
            Object.assign({}, this.props);
        const elementType = this.props.multiline ? "textarea" : "input";
        //Quitamos los props que no le pertenecen al textarea ni al input
        const { multiline, selectAllOnFocus, onEnter } = props, newProps = __rest(props, ["multiline", "selectAllOnFocus", "onEnter"]);
        const element = React.createElement(elementType, Object.assign({}, newProps, { onKeyPress: this.handleKeyPress, onChange: this.handleOnChange, value: this.props.value }));
        return element;
    }
}
exports.SlowInput = SlowInput;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/slowInput.js
// module id = 2213
// module chunks = 0